function TimezoneMap (value = null) {
  let data = [
    {
      label: '(GMT) UTC',
      value: 'UTC'
    },
    {
      label: '(GMT-11:00) Midway Islands',
      value: 'Pacific/Midway'
    },
    {
      label: '(GMT-11:00) Niue',
      value: 'Pacific/Niue'
    },
    {
      label: '(GMT-10:00) Hawaii',
      value: 'Pacific/Honolulu'
    },
    {
      label: '(GMT-09:00) Nome',
      value: 'America/Nome'
    },
    {
      label: '(GMT-08:00) Tijuana',
      value: 'America/Tijuana'
    },
    {
      label: '(GMT-07:00) Chihuahua',
      value: 'America/Chihuahua'
    },
    {
      label: '(GMT-07:00) Mazatlan',
      value: 'America/Mazatlan'
    },
    {
      label: '(GMT-06:00) Mexico City',
      value: 'America/Mexico_City'
    },
    {
      label: '(GMT-06:00) Monterrey',
      value: 'America/Monterrey'
    },
    {
      label: '(GMT-05:00) Bogota',
      value: 'America/Bogota'
    },
    {
      label: '(GMT-05:00) Lima',
      value: 'America/Lima'
    },
    {
      label: '(GMT-05:00) Tortola',
      value: 'America/Tortola'
    },
    {
      label: '(GMT-04:00) Barbados',
      value: 'America/Barbados'
    },
    {
      label: '(GMT-04:00) Caracas',
      value: 'America/Caracas'
    },
    {
      label: '(GMT-03:00) Santiago',
      value: 'America/Santiago'
    },
    {
      label: '(GMT-02:00) Noronha',
      value: 'America/Noronha'
    },
    {
      label: '(GMT-02:00) South Georgia',
      value: 'Atlantic/South_Georgia'
    },
    {
      label: '(GMT-01:00) Azores',
      value: 'Atlantic/Azores'
    },
    {
      label: '(GMT) London',
      value: 'Europe/London'
    },
    {
      label: '(GMT+01:00) Rome',
      value: 'Europe/Rome'
    },
    {
      label: '(GMT+01:00) Ndjamena',
      value: 'Africa/Ndjamena'
    },
    {
      label: '(GMT+02:00) West Bank',
      value: 'Asia/Hebron'
    },
    {
      label: '(GMT+02:00) Amman',
      value: 'Asia/Amman'
    },
    {
      label: '(GMT+02:00) Athens',
      value: 'Europe/Athens'
    },
    {
      label: '(GMT+02:00) Bucharest',
      value: 'Europe/Bucharest'
    },
    {
      label: '(GMT+03:00) Istanbul',
      value: 'Europe/Istanbul'
    },
    {
      label: '(GMT+03:00) Kuwait',
      value: 'Asia/Kuwait'
    },
    {
      label: '(GMT+03:30) Tehran',
      value: 'Asia/Tehran'
    },
    {
      label: '(GMT+04:00) Baku',
      value: 'Asia/Baku'
    },
    {
      label: '(GMT+04:30) Kabul',
      value: 'Asia/Kabul'
    },
    {
      label: '(GMT+05:00) Karachi',
      value: 'Asia/Karachi'
    },
    {
      label: '(GMT+05:30) Kolkata',
      value: 'Asia/Kolkata'
    },
    {
      label: '(GMT+06:00) Dhaka',
      value: 'Asia/Dhaka'
    },
    {
      label: '(GMT+07:00) Novosibirsk',
      value: 'Asia/Novosibirsk'
    },
    {
      label: '(GMT+08:00) Shanghai',
      value: 'Asia/Shanghai'
    },
    {
      label: '(GMT+08:00) Singapore',
      value: 'Asia/Singapore'
    },
    {
      label: '(GMT+09:00) Seoul',
      value: 'Asia/Seoul'
    },
    {
      label: '(GMT+10:00) Vladivostok',
      value: 'Asia/Vladivostok'
    },
    {
      label: '(GMT+10:00) Brisbane',
      value: 'Australia/Brisbane'
    },
    {
      label: '(GMT+11:00) Sydney',
      value: 'Australia/Sydney'
    },
    {
      label: '(GMT+12:00) Fiji',
      value: 'Pacific/Fiji'
    },
    {
      label: '(GMT+12:00) Kwajalein',
      value: 'Pacific/Kwajalein'
    },
    {
      label: '(GMT+13:00) Apia',
      value: 'Pacific/Apia'
    },
    {
      label: '(GMT+13:00) Auckland',
      value: 'Pacific/Auckland'
    }
  ]
  if (value) {
    let label = value
    data.forEach(item => {
      if (item.value === value) {
        label = item.label
      }
    })
    return label
  }
  return data
}

export { TimezoneMap }